import { render, staticRenderFns } from "./TotalItemWrapper.vue?vue&type=template&id=5b3a7853&scoped=true&"
import script from "./TotalItemWrapper.vue?vue&type=script&lang=js&"
export * from "./TotalItemWrapper.vue?vue&type=script&lang=js&"
import style0 from "./TotalItemWrapper.vue?vue&type=style&index=0&id=5b3a7853&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3a7853",
  null
  
)

export default component.exports